import { render, staticRenderFns } from "./Source.vue?vue&type=template&id=2542c9fa&scoped=true"
import script from "./Source.vue?vue&type=script&lang=js"
export * from "./Source.vue?vue&type=script&lang=js"
import style0 from "./Source.vue?vue&type=style&index=0&id=2542c9fa&prod&lang=scss"
import style1 from "./Source.vue?vue&type=style&index=1&id=2542c9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2542c9fa",
  null
  
)

export default component.exports